<template>
  <div v-if="priceList && priceList.id"  class="hide-cancel">
    <modalWindow v-model="showModel" @cancel="cancel()" @ok="cancel()" @closed="onClose()" :title="'Cenník pre ' + priceList.customer.companyName" okText="Zavrieť" cancelText="Zrušiť">
      <div class="row">
        <div class="col-md-12">
          <dl class="dl-horizontal">
            <dt>Zákazník</dt>
            <dd>{{ priceList.customer.companyName }}</dd>
            <dt>Platnosť od</dt>
            <dd>{{ priceList.validFrom | date }}</dd>
            <dt>Platnosť do</dt>
            <dd>{{ priceList.validTo | date }}</dd>
          </dl>
          <hr />
          <h4>Položky</h4>
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Produkt</th>
              <th>Cena</th>
            </tr>
            </thead>
            <tbody>
              <template v-for="item in priceList.items">
                <tr>
                  <td>{{ item.product.label }}</td>
                  <td>{{ item.price | currency }}</td>
                </tr>
              </template>
            </tbody>
          </table>

        </div>
      </div>
    </modalWindow>
  </div>
</template>

<script>
  import modal from 'vue-strap/src/Modal';
  import { mapState } from 'vuex';
  import _ from 'lodash';

  export default {
    components: {modalWindow: modal},
    props: {
      showModel: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object
      },
    },
    computed: {
      priceList() {
        return this.model;
      }
    },
    methods: {
      onClose() {
        this.unprotect();
      },
      cancel() {
        this.protect();
        this.$emit('close');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/priceListDetailModal.vue